import router from "@/router";
import device from "current-device";
import scroll from "@/helpers/scroll";

export default {
    isIosApp: state => {
        return state.isApp && device.ios();
    },
    PROFILE: state => {
        return state.profile;
    },
    LIB: state => {
        return state.lib;
    },
    oldCarsLoaded: state => {
        return state.dataOldCarsLoadedFlag;
    },
    carLoaded: state => {
        if (router.currentRoute.name === 'DealerCar') {
            return state.dealers.dataCarLoadedFlag;
        } else {
            return state.moduleOldCars.carLoaded;
        }
    },
    onFilterBrandsFlag: state => {
        return state.onFilterBrandsFlag;
    },
    notifications: state => {
        if (state.notifications) {
            return state.notifications;
        }
    },
    showMenu: state => {
        //scroll.to(0);
        return state.showMenu;
    },
    lastCarPageVisit:  state => {
        return state.lastCarPageVisit;
    }
}